import styled from 'styled-components';

export const OnboardingTutorialSelectOrderSideButtonsContainerStyled = styled.div`
    display: flex;
    gap: 6px;
    width: 100%;
`;

export const OnboardingTutorialSelectOrderSideButtonStyled = styled.div`
    height: 48px;
    border-radius: 2px;
    background-color: #48495E;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 700;
    font-size: 16px;
    color: #93939F;
    
    &.sell {
        cursor: pointer;
        background-color: #9E3E49;
        color: var(--color-white);
    }
`;
